<template>
  <v-container>
    <h2>
      <span>Family Report</span>
    </h2>
    <v-alert v-if="globalServerErrors !== null" dense outlined type="error">
      <p class="mb-0" v-for="globalErr in globalServerErrors" :key="globalErr">
        {{ globalErr[0] }}
      </p>
    </v-alert>
    <formWrapper :validator="$v.form">
      <form class="form-box">
        <v-row>
          <v-col class="mx-auto" sm="8" cols="12">
            <v-row>
              <v-col class="py-1" cols="12" md="12">
                <v-autocomplete
                  :items="familyCamps"
                  item-text="name"
                  item-value="id"
                  regular
                  label="Camp Name"
                  return-object
                  multiple
                  chips
                  v-model="form.camp_id"
                  :loading="loadingCamps"
                ></v-autocomplete>
                <!-- :append-icon="form.camp_id ? 'mdi-close' : ''"
                  @click="clearCamps" -->
              </v-col>

              <v-col class="py-1" cols="12" sm="6">
                <v-menu
                  ref="menu1"
                  v-model="menu1"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="form.created_at_from"
                      label="Created At From"
                      regular
                      persistent-hint
                      :append-icon="form.created_at_from ? 'mdi-close' : ''"
                      @click:append="clearMenu1"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="form.created_at_from"
                    no-title
                    @input="menu1 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col class="py-1" cols="12" sm="6">
                <v-menu
                  ref="menu2"
                  v-model="menu2"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="form.created_at_to"
                      label="Created At To"
                      regular
                      persistent-hint
                      :append-icon="form.created_at_to ? 'mdi-close' : ''"
                      @click:append="clearMenu2"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="form.created_at_to"
                    no-title
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col class="py-1" cols="12" sm="6">
                <v-menu
                  ref="menu3"
                  v-model="menu3"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="form.updated_at_from"
                      label="Updated At From"
                      regular
                      persistent-hint
                      :append-icon="form.updated_at_from ? 'mdi-close' : ''"
                      @click:append="clearMenu3"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="form.updated_at_from"
                    no-title
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col class="py-1" cols="12" sm="6">
                <v-menu
                  ref="menu4"
                  v-model="menu4"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="form.updated_at_to"
                      label="Updated At To"
                      regular
                      persistent-hint
                      :append-icon="form.updated_at_to ? 'mdi-close' : ''"
                      @click:append="clearMenu4"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="form.updated_at_to"
                    no-title
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col class="py-1" sm="6" cols="12">
                <v-select
                  :items="cashiers"
                  item-text="name"
                  item-value="id"
                  label="Cashier"
                  regular
                  :append-icon="form.cashier_id ? 'mdi-close' : ''"
                  @click:append="clearCashier"
                  v-model="form.cashier_id"
                  :loading="loadingCamps"
                ></v-select>
              </v-col>
              <v-col class="py-1" sm="6" cols="12">
                <v-select
                  :items="paymentMethods"
                  item-text="name"
                  item-value="id"
                  regular
                  :append-icon="form.payment_method_id ? 'mdi-close' : ''"
                  @click:append="clearPayment"
                  label="Payment Method"
                  v-model="form.payment_method_id"
                  :loading="loadingCamps"
                ></v-select>
              </v-col>
              <v-col cols="12" md="4" class="mx-auto my-0 pa-0">
                <v-checkbox
                  class="my-0 pa-0"
                  label="All Statuses"
                  v-model.number="form.all_statuses"
                  :false-value="0"
                  :true-value="1"
                ></v-checkbox>
              </v-col>
              <v-col cols="12">
                <v-btn
                  v-if="!downloading"
                  class="text-capitalize"
                  large
                  rounded
                  color="error"
                  outlined
                  @click="handleSave()"
                  width="100%"
                  :disabled="$v.form.$invalid"
                  :loading="loadingRequest"
                  ><span>Export</span>
                </v-btn>
                <v-btn
                  class="text-capitalize"
                  large
                  rounded
                  width="100%"
                  color="success"
                  outlined
                  v-else
                  :href="url"
                  @click="download"
                  >Download</v-btn
                >
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </form>
    </formWrapper>
  </v-container>
</template>

<script>
import { ExportData, IndexDataQuery } from "@/helpers/apiMethods";
// import { required } from "vuelidate/lib/validators";
// import FileSaver from "file-saver";
export default {
  data() {
    return {
      form: {
        all_statuses: 0
      },
      downloading: false,
      loadingRequest: false,
      loadingCamps: false,
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      loadingData: false,
      cashiers: [],
      paymentMethods: [],
      discounts: {
        id: null,
        value: null,
        name: "",
        value_type: null,
        expiry_date: { date: "" }
      },
      discoutsItems: [],
      familyCamps: [],
      globalServerErrors: null
    };
  },

  created() {
    this.indexLists();
  },
  methods: {
    indexLists() {
      this.loadingCamps = true;
      IndexDataQuery({ reqName: `/reports/lists` })
        .then(res => {
          // const { data } = res.data;
          this.familyCamps = res.data.family_camps;
          this.cashiers = res.data.cashiers;
          this.paymentMethods = res.data.payment_methods;
          this.loadingCamps = false;
        })
        .catch(() => {})
        .finally(() => {});
    },
    handleSave() {
      this.familyExport();
    },
    familyExport() {
      this.loadingRequest = true;
      const formData = new FormData();
      Object.keys(this.form).forEach(formItem => {
        if (formItem == "camp_id" || this.form[formItem] == "") {
          return;
        } else {
          formData.append(formItem, this.form[formItem]);
        }
      });
      if (this.form.camp_id) {
        this.form.camp_id.forEach(campID => {
          formData.append(`camp_id[]`, campID["id"]);
        });
      }
      if (Object.keys(this.form).length === 0) {
        this.familyCamps.forEach(campID => {
          formData.append(`camp_id[]`, campID["id"]);
        });
      }
      ExportData({
        reqName: `reports/family`,
        data: formData
      })
        .then(res => {
          this.url = res.data.url;
          this.loadingRequest = false;
          this.downloading = true;
        })
        .catch(err => {
          this.globalServerErrors = err.response.data.errors;
          this.scrollTop();
        })
        .finally(() => {
          this.loadingRequest = false;
        });
    },
    download() {
      this.downloading = false;
      this.form = {};
    },
    forceFileDownload(response) {
      const url = URL.createObjectURL(new Blob([response.data]), {
        type: "application/text"
      });
      const link = document.createElement("a");
      link.href = url;
      link.download = "file.xlsx";
      // link.setAttribute("download", `${response.config.url}.xlsx`); //or any other extension
      // document.body.appendChild(link);
      link.click();
    },
    reset() {
      this.$v.form.$reset();
      (this.form = {
        id: "",
        value_type: ""
      }),
        this.$store.dispatch("ClearServerErrors");
    },
    scrollTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    clearCamps() {
      this.form.camp_id = "";
    },
    clearMenu1() {
      this.form.created_at_from = "";
    },
    clearMenu2() {
      this.form.created_at_to = "";
    },
    clearMenu3() {
      this.form.updated_at_from = "";
    },
    clearMenu4() {
      this.form.updated_at_to = "";
    },
    clearCashier() {
      this.form.cashier_id = "";
    },
    clearPayment() {
      this.form.payment_method_id = "";
    }
  },
  validations: {
    form: {
      // camp_id: {
      //   required
      // }
    }
  }
};
</script>
